import React from 'react'
import PropTypes from 'prop-types'
import './form.scss'

import { ButtonGroup } from 'components'
import { useTranslate } from 'react-polyglot'

const Form = ({ actions, children, error, onSubmit, ...rest }) => {
	const t = useTranslate()

	return (
		<form className="c-form" onSubmit={onSubmit} {...rest}>
			{children}

			{actions && (
				<ButtonGroup orientation="horizontal">{actions}</ButtonGroup>
			)}

			{error && (
				<div className="c-form__error">{t(`errors.${error}`)}</div>
			)}
		</form>
	)
}

Form.propTypes = {
	actions: PropTypes.node,
	children: PropTypes.node,
	error: PropTypes.node,
	onSubmit: PropTypes.func,
}

Form.defaultProps = {
	actions: null,
	children: null,
	error: null,
	onSubmit: null,
}

export default Form
